// extracted by mini-css-extract-plugin
export default {"main":"ListTranslationsView_main__EZON6","list":"ListTranslationsView_list__CNDHc","caption":"ListTranslationsView_caption__FlOhL"};